/* eslint-disable array-callback-return */
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  Radio,
  TextField,
  Typography
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as CommonStyles from "./CommonStyles";
import "./CommonStyles.scss";

const useStyles = makeStyles({
  paper: {
    // display: "grid",
    // gridTemplateColumns: "repeat(3, 1fr)",
    maxHeight: "501px !important",
    top: "1px !important",
    boxShadow: "4px 8px 16px 0px rgba(48, 48, 108, 0.32)",
    marginTop: "1px"
  }
});

interface Props {
  name: string;
  title: string;
  description: string;
  options: any;
  values?: any;
  isRadioOption?: boolean;
  width?: number | string | null | undefined;
  onChange: any;
  onClose: (event: any, reason: string) => void;
  disabled?: boolean;
}

const MultiSelectDropDown: FC<Props> = ({
  name,
  title,
  description,
  options = [],
  values = {},
  isRadioOption = false,
  width = "532px",
  onChange,
  onClose,
  disabled = false
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [selectedOptionList, setSelectedOptionList] = useState<any>([]);
  const [itemsTodisplay, setItemsToDisplay] = useState<any>({
    showItemsCount: 3,
    expanded: false
  });
  const getSelectedOptions = () => {
    const selectedOptions =
      options.filter(
        (option: any) => values[option.key] && option.key !== "All"
      ) || [];
    return selectedOptions;
  };

  const showMoreClick = () => {
    itemsTodisplay.showItemsCount === 3
      ? setItemsToDisplay({
          showItemsCount: selectedOptionList.length,
          expanded: true
        })
      : setItemsToDisplay({ showItemsCount: 3, expanded: false });
  };

  useEffect(() => {
    const selectedOptionsList = getSelectedOptions();
    if (itemsTodisplay.expanded) {
      const updateItemsToDisplay =
        selectedOptionsList.length > 3
          ? { showItemsCount: selectedOptionsList.length, expanded: true }
          : { showItemsCount: 3, expanded: false };
      setItemsToDisplay(updateItemsToDisplay);
    }
    setSelectedOptionList(selectedOptionsList);
  }, [values, options]);

  return (
    <Box className="filter-section">
      <h4 style={CommonStyles.titleElement}>{t(title)}</h4>
      <Typography sx={CommonStyles.descriptionElement}>
        {t(description)}
      </Typography>

      {isRadioOption ? (
        <Autocomplete
          multiple={!isRadioOption}
          fullWidth
          size="small"
          disabled={disabled}
          sx={{ width: width }}
          classes={{ paper: classes.paper }}
          options={options}
          getOptionLabel={(option: any) => option.label}
          renderTags={() => {
            return null;
          }}
          renderOption={(props, option) => {
            return (
              <li
                {...props}
                key={option.key + option.label}
                onClick={(e: any) => {
                  if (!disabled) onChange(option.key);
                }}
              >
                <Radio
                  name={name}
                  style={{ marginRight: 4 }}
                  disabled={disabled}
                  checked={values[option.key] ? true : false}
                />
                {option.label}
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={"Select an option"}
              prefix={(params.inputProps.value = selectedOptionList[0]?.label)}
            />
          )}
        />
      ) : (
        <Autocomplete
          multiple={!isRadioOption}
          fullWidth
          size="small"
          disabled={disabled}
          sx={{ width: width }}
          options={options}
          classes={{ paper: classes.paper }}
          getOptionLabel={(option: any) => option.label}
          renderTags={() => {
            return null;
          }}
          renderOption={(props, option) => {
            if (!isRadioOption) {
              return (
                <li
                  {...props}
                  key={option.key + option.label}
                  onClick={(e: any) => {
                    if (!disabled) onChange(option.key);
                  }}
                >
                  <Checkbox
                    name={name}
                    indeterminate={values[option.key] === "Indeterminate"}
                    style={{ marginRight: 4 }}
                    color="secondary"
                    disabled={disabled}
                    checked={values[option.key] ? true : false}
                    sx={{
                      pointerEvents: "auto",
                      "&.Mui-checked, &.MuiCheckbox-indeterminate": {
                        color: "var(--primary-color)"
                      }
                    }}
                  />
                  {option.label}
                </li>
              );
            } else {
              return (
                <li
                  {...props}
                  key={option.key + option.label}
                  onClick={(e: any) => {
                    if (!disabled) onChange(option.key);
                  }}
                >
                  <Radio
                    name={name}
                    style={{ marginRight: 4 }}
                    disabled={disabled}
                    checked={values[option.key] ? true : false}
                  />
                  {option.label}
                </li>
              );
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={
                options.length - 1 === selectedOptionList.length
                  ? t("pa.allSelected")
                  : selectedOptionList.length && !isRadioOption
                    ? t("pa.selectMore")
                    : t("pa.selectAnOption")
              }
            />
          )}
          onClose={(event: any, reason: string) => {
            onClose(event, reason);
          }}
        />
      )}
      <Box className="selected-chips-wrapper">
        {!isRadioOption &&
          selectedOptionList
            .slice(0, itemsTodisplay.showItemsCount)
            .map((item: any, index: number) => {
              return (
                <Chip
                  key={`chip-${name}-${item.key}-${index}`}
                  label={item.label}
                  style={{ marginBottom: 8 }}
                  deleteIcon={disabled ? undefined : <CloseIcon />}
                  onDelete={
                    disabled
                      ? undefined
                      : () => {
                          onChange(item.key, "CLEAR");
                        }
                  }
                />
              );
            })}
        <span className="viewMore">
          {selectedOptionList.length > 3 && (
            <a
              href="#"
              onClick={() => {
                showMoreClick();
              }}
            >
              {itemsTodisplay.expanded ? (
                <span>{t("pa.viewLess")}</span>
              ) : (
                <span>
                  +{selectedOptionList.length - 3} {t("pa.more")}
                </span>
              )}
            </a>
          )}
          {selectedOptionList.length > 1 && !isRadioOption && !disabled && (
            <a
              href="#"
              onClick={() => {
                onChange("CLEAR_ALL") &&
                  setItemsToDisplay({ showItemsCount: 3, expanded: false });
              }}
            >
              {t("pa.clearAllFilters")}
            </a>
          )}
        </span>
      </Box>
    </Box>
  );
};

export default MultiSelectDropDown;
